module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABVUlEQVRYR+1Xy03DQBB9rwLCGSQoABGoIOmAUAFcvBw9VJBQAeMjvkAJlGA6SJQGjAT3iAYGrbVCFgrBjiX7siP54NHMvLdvf7PEwMaB8REJ0Dk3M7M5yYuep6MEcM8kSUqSJz2DV3BmtvQKWPh5I1n0QcTMpiQnHuuHAICHPM8XIjIiOTazlapufFDwTYLPS1eZiMwAlKq6bEPcObcAMN9KIE3TNckzAGtVPQ9ALwBuzOwry7KD4LsF8ByAL9uQ+I/AB8kjM/vMsuw4gL0CuApgh14ZEREAj8F3rao+ppHtJCAiUwD+K1S1WhMicgrAj7juGwXfRlW9Qo3tLwI5gKfGVboF3gFwv9dAt5J7Ztd3wZ4luqXVCQw+BdU50G08zbJ37oJmJbpFRQJRgahAVGCrAmZW9NyS+SsfgzalAFZVWw7A3wHjbgdsu2wzeycp8WUUFfgGyz7j+SDpn5gAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/resour.png
// module id = hydB
// module chunks = 96